import { render, staticRenderFns } from "./CoreCompetencies.vue?vue&type=template&id=2821faa2&scoped=true"
import script from "./CoreCompetencies.vue?vue&type=script&lang=js"
export * from "./CoreCompetencies.vue?vue&type=script&lang=js"
import style0 from "./CoreCompetencies.vue?vue&type=style&index=0&id=2821faa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2821faa2",
  null
  
)

export default component.exports